var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#0A0B18"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8968 15.6093C28.8385 15.672 28.7678 15.7218 28.6891 15.7556C28.6105 15.7893 28.5256 15.8064 28.44 15.8056H20.493V22.7315H25.8237C25.9956 22.7362 26.159 22.8065 26.2806 22.9279C26.4021 23.0494 26.4724 23.2127 26.4772 23.3843V26.8818C26.4779 26.9673 26.4609 27.0521 26.427 27.1307C26.3932 27.2093 26.3433 27.2799 26.2806 27.3382C26.2219 27.4003 26.151 27.4498 26.0725 27.4836C25.9939 27.5173 25.9093 27.5347 25.8237 27.5346H20.493V33.1549C20.4958 33.2454 20.4797 33.3355 20.4459 33.4196C20.4121 33.5036 20.3612 33.5797 20.2964 33.6431C20.2377 33.7053 20.1669 33.7547 20.0883 33.7885C20.0098 33.8223 19.9251 33.8396 19.8396 33.8395H15.6536C15.5681 33.8396 15.4834 33.8223 15.4048 33.7885C15.3263 33.7547 15.2554 33.7053 15.1967 33.6431C15.1325 33.5793 15.0819 33.5032 15.0481 33.4192C15.0144 33.3352 14.998 33.2453 15.0002 33.1549V11.6607C14.9994 11.574 15.0165 11.4881 15.0503 11.4082C15.0841 11.3283 15.1339 11.2562 15.1967 11.1964C15.2554 11.1342 15.3263 11.0847 15.4048 11.051C15.4834 11.0172 15.5681 10.9999 15.6536 11H28.44C28.6122 11.0047 28.7761 11.0754 28.8977 11.1973C29.0193 11.3193 29.0893 11.4833 29.0934 11.6555V15.1529C29.0941 15.2384 29.0771 15.3232 29.0432 15.4018C29.0094 15.4804 28.9595 15.551 28.8968 15.6093Z",
    fill: "#FCD606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a195af36b38bbd7317948fbf2f252492.svg";
export { ForwardRef as ReactComponent };